import React from 'react';

const WardrobePlanner: React.FC = () => {
  const onlineStores = [
    {
      name: 'Aza Fashions',
      description: 'Premium designer collections and bridal wear',
      url: 'https://www.azafashions.com/'
    },
    {
      name: 'Kalki',
      description: 'Traditional and fusion Indian outfits',
      url: 'https://www.kalkifashion.com/'
    },
    {
      name: 'KYNAH',
      description: 'Contemporary Indian fashion and festive attire',
      url: 'https://www.kynah.com/'
    },
    {
      name: 'Lashkaraa',
      description: 'Authentic Indian ethnic wear and accessories',
      url: 'https://www.lashkaraa.com/'
    },
    {
      name: 'Pernia\'s Pop-Up Shop',
      description: 'Curated designer wear and luxury Indian fashion',
      url: 'https://www.perniaspopupshop.com/'
    }
  ];

  const inStoreOptions = [
    {
      location: 'New York',
      stores: [
        { name: 'Heritage India Fashions', url: 'https://maps.google.com/?q=Heritage+India+Fashions+New+York' },
        { name: 'Aayka Fashion', url: 'https://maps.google.com/?q=Aayka+Fashion+New+York' }
      ]
    },
    {
      location: 'New Jersey',
      stores: [
        { name: 'Nazranaa', url: 'https://maps.google.com/?q=Nazranaa+New+Jersey' },
        { name: 'Manyavar/Mohey', url: 'https://maps.google.com/?q=Manyavar+Mohey+New+Jersey' }
      ]
    },
    {
      location: 'Chicago',
      stores: [
        { name: 'Manyavar/Mohey', url: 'https://maps.google.com/?q=Manyavar+Mohey+Devon+Ave+Chicago' }
      ]
    }
  ];

  return (
    <div>
      <div className="text-center">
        <h1 className="text-4xl font-display font-medium text-sage-800 mb-4">
          The Wardrobe Planner
        </h1>
        <div className="elegant-divider"></div>
        <p className="text-sage-grey-600">
          Whether you're new to Indian wedding attire or simply looking for inspiration, here are some helpful resources and trusted retailers to help you find the perfect outfit for the celebration.
        </p>
      </div>

      {/* Image Placeholder 1 */}
      <div className="w-full mx-auto mt-12">
        <img
          src="/images/wardrobe-planner/outfit-1.jpg"
          alt="Indian Wedding Attire"
          className="w-full h-auto"
          style={{ filter: 'none' }}
        />
      </div>

      {/* Image Placeholder 2 */}
      <div className="w-full mx-auto mt-24">
        <img
          src="/images/wardrobe-planner/outfit-2.jpg"
          alt="Indian Fashion Styles"
          className="w-full h-auto"
          style={{ filter: 'none' }}
        />
      </div>

      {/* Image Placeholder 3 */}
      <div className="w-full mx-auto mt-24">
        <img
          src="/images/wardrobe-planner/outfit-3.jpg"
          alt="Indian Wedding Guest Attire"
          className="w-full h-auto"
          style={{ filter: 'none' }}
        />
      </div>

      {/* Shopping Resources - Combined Section */}
      <div className="glass-card p-12 mt-12">
        <div className="mb-8">
          <h2 className="font-display text-soft-black tracking-wide text-center">
            Where to Shop
          </h2>
          <div className="elegant-divider"></div>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Online Shopping */}
          <div>
            <h3 className="font-display text-soft-black text-xl tracking-wide mb-6 text-center">
              ONLINE
            </h3>
            <div className="space-y-3">
              {onlineStores.map((store, index) => (
                <div key={index} className="text-center">
                  <a
                    href={store.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-text-gray hover:text-soft-black transition-colors duration-300 underline decoration-1 underline-offset-4"
                  >
                    {store.name}
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* In-Store Shopping */}
          <div>
            <h3 className="font-display text-soft-black text-xl tracking-wide mb-6 text-center">
              IN-STORE
            </h3>
            <div className="space-y-3">
              {inStoreOptions.map((region) => (
                region.stores.map((store, storeIndex) => (
                  <div key={storeIndex} className="text-center">
                    <a
                      href={store.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-text-gray hover:text-soft-black transition-colors duration-300 underline decoration-1 underline-offset-4"
                    >
                      {store.name} ({region.location})
                    </a>
                  </div>
                ))
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WardrobePlanner;
